import { routes } from "@/app/navigation/routes";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useForceMobileUpdateViewModel = () => {
  const [mobile, setMobile] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    console.log("Mobile:", mobile);

    // call API here

    navigate(routes.home);
  };

  return {
    mobile,
    setMobile,
    handleSubmit,
  };
};
